<app-split-pane
  storageKey="split.code"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.code.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="codeSuggestions" [context]="codeContext" placeholder="Ask or generate code..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="code.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.code.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="container">
          <div>Code editor and file tree placeholder</div>
          <ul>
            <li>File browser</li>
            <li>Editor area</li>
            <li>Preview/terminal</li>
          </ul>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="code.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
